// extracted by mini-css-extract-plugin
export default {"stickBorder":"index_stickBorder_Hwmov"};